import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { Grid, Text } from 'elements';
import { TCaseExplain } from 'modules/case/types';
import { CWindowWidth } from 'constants/base.const';
import { Grid as AGrid, Button, Select } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import Card from './Card';

const { useBreakpoint } = AGrid;

type TMentorExplain = {
  explains: Array<TCaseExplain>;
  getExplains: (args1: string) => void;
  onClick: (args1: number) => void;
};

const MentorExplain = ({ explains, getExplains, onClick }: TMentorExplain) => {
  const screens = useBreakpoint();
  const [slider, setSlider] = useState<Slider | null>();
  const [selectedOrder, setSelectedOrder] = useState('rating');

  const setRate = (explain: TCaseExplain) => {
    return Array.isArray(explain.ratings) && explain.ratings[0] ? Number(explain.ratings[0]) : 0;
  };

  const setRateText = (explain: TCaseExplain) => {
    return Array.isArray(explain.ratings) && explain.ratings[1] ? `“${explain.ratings[1]}“` : '';
  };

  const change = (b: number, n: number) => {};

  useEffect(() => {
    getExplains(selectedOrder);
  }, [selectedOrder]);

  if (explains.length === 0) return null;

  return (
    <Grid maxWidth={`${CWindowWidth}px`} padding='50px 50px 0 50px' sm={{ padding: '20px 20px 0 20px' }}>
      <Grid>
        <Text size='2rem' sm={{ size: '1.6rem' }}>
          멘토 해설
        </Text>
      </Grid>
      <Grid marginTop='12px'>
        <Text size='1.1rem'>
          Career Step 멘토가 직접 풀이한 해설. 멘토의 개성이 엿보이는 다양한 풀이와 비즈니스 센스를 확인해
          보세요. (해설은 유료이며, 멘토가 직접 가격을 설정합니다.)
        </Text>
      </Grid>
      <Grid marginTop='12px'>
        <Grid justify='space-between'>
          <Grid isInline gap='8px'>
            <Button type='text' icon={<LeftOutlined />} onClick={() => slider?.slickPrev()} />
            <Button type='text' icon={<RightOutlined />} onClick={() => slider?.slickNext()} />
          </Grid>
          <Select value={selectedOrder} onChange={setSelectedOrder}>
            <Select.Option value='rating'>평점순</Select.Option>
            <Select.Option value='new'>최신순</Select.Option>
            <Select.Option value='view'>조회순</Select.Option>
          </Select>
        </Grid>
        <Grid overflow='hidden'>
          <Grid display='block' marginTop='12px' position='relative' width='calc(100% + 20px)'>
            <Slider
              ref={(s) => setSlider(s)}
              beforeChange={change}
              dots={false}
              arrows={false}
              slidesToScroll={1}
              slidesToShow={screens.lg ? (explains.length < 4 ? explains.length : 4) : 1}
              centerPadding={screens.lg ? '0px' : screens.md ? '100px' : '0px'}
              centerMode={!screens.lg}
            >
              {explains.map((explain, index) => (
                <Grid padding='0 20px 0 0' key={index} maxWidth='294px' md={{ maxWidth: '528px' }}>
                  <Card
                    name={explain.name}
                    subTitle={
                      explain.mentor.short_introduction ? `“${explain.mentor.short_introduction}”` : ''
                    }
                    thumbnail={explain.mentor.profile_image}
                    thumbnailTitle={explain.mentor.is_current}
                    rateCount={explain.rating_count}
                    rate={setRate(explain)}
                    rateTitle={setRateText(explain)}
                    price={`${(Number(explain.price) * 1000).toLocaleString()} 원`}
                    isPurchase={explain.is_payed}
                    career={
                      <Grid>
                        {!!explain.mentor.company && (
                          <Grid justify='space-between'>
                            <Text>{explain.mentor.company}</Text>
                            <Text>{explain.mentor.duration} 근무</Text>
                          </Grid>
                        )}
                        {explain.mentor.university && explain.mentor.major && (
                          <Grid>
                            <Text>
                              {explain.mentor.university} {explain.mentor.major} 졸업
                            </Text>
                          </Grid>
                        )}
                      </Grid>
                    }
                    questions={explain.key_question}
                    onClick={() => onClick(explain.id)}
                  />
                </Grid>
              ))}
            </Slider>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MentorExplain;
